<!-- MainLayout.vue -->
<template>
  <slot />
</template>

<script>
export default {
  name: 'MainLayout'
};
</script>